import React from 'react';
import { SectionHeading } from './SectionHeading';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
export function Intro() {
  return <section aria-labelledby="intro-title" className="relative bg-ink py-20 sm:py-28" data-id="element-104" data-mp="27iky2shwuaqd">
      <TornEdge colorClassName="bg-ink" data-id="element-105" data-mp="2ldnbs1t014dq" />
      <div aria-hidden="true" className="gold-dust pointer-events-none absolute inset-0 opacity-25" data-id="element-106" data-mp="2ggn2li0urlie" />
      <div className="relative mx-auto w-full max-w-3xl px-5 sm:px-8" data-id="element-107" data-mp="1srvildxf29gp">
        <Reveal data-id="element-108" data-mp="1nt0t5t4y1mnm">
          <SectionHeading id="intro-title" folio="Exp. 000 · Nuestra labor" title="Prácticas Espirituales Tradicionales" data-id="element-109" data-mp="1ntk7z0zaruxf">
            <div className="space-y-6 text-center text-[0.98rem] leading-relaxed text-body sm:text-lg" data-id="element-110" data-mp="1xpx21zyr8asp">
              <p data-id="element-111" data-mp="1a02rxq5tl0c5">
                Ofrecemos consultas y rituales personalizados para personas que
                desean explorar diferentes aspectos de su vida sentimental,
                personal y espiritual.
              </p>
              <p data-id="element-112" data-mp="1pu1unbdkzip">
                Cada consulta se aborda de manera personalizada de acuerdo con
                las circunstancias de cada persona y desde una perspectiva de
                prácticas espirituales tradicionales.
              </p>
            </div>
          </SectionHeading>
        </Reveal>
      </div>
    </section>;
}